

(function($) { "use strict";

	// Sound waves
	// check page contains element

	window.swoffset = 0;

	$('.sound-waves').each(function(){

		//color schemes are applied via .is-style-bg-?  and .is-style-fg-?
		// var sound_waves_bg_color = '';
		var sound_waves_fg_color = '';
		const container_classes = jQuery(this).closest(".js-has-color-scheme").attr('class').split(/\s+/);
		const colors = {
			'vermillion': '#C92E2B',
			'scarlett': '#571A21',
			'mandarin': '#F95A3E',
			'sunburst': '#FAC938',
			'salmon': '#ED9EA6',
			'navy': '#556589',
			'cornflower': '#8AABAD',
			'lightgrey': '#F6F6F6',
			'lightvermillion': '#9A767A',
			'white': '#ffffff',
			'black': '#000000',
		};

		jQuery.each(container_classes, function(index, classname) {
			// if (classname.startsWith('is-style-bg-')) {
			// 	sound_waves_bg_color = colors[classname.replace('is-style-bg-','')];
			// }
			if (classname.startsWith('is-style-fg-')) {
				sound_waves_fg_color = colors[classname.replace('is-style-fg-','')];
			}
		});

		// var c = document.getElementById('canvas');
		var c = this;
		var $ = c.getContext('2d');

		var w = c.width = window.innerWidth;
		var h = c.height = window.innerHeight;

		var intLines = 10;
		var draw = function(t, offset, invert_midpoints, invert_endpoints, screen, flip) {
			$.lineWidth = 2.5;
			// $.fillStyle = '#571A21'; //Scarlett
			// $.fillStyle = sound_waves_bg_color; //'#F95A3E'; //Mandarin
			$.clearRect(0, 0, w, h);

			for (var i = 0; i < intLines; i++) {
				// $.strokeStyle = '#F95A3E'; //Mandarin
				$.strokeStyle = sound_waves_fg_color; //'#571A21'; //Scarlett
				$.beginPath();

				const angle_multiplier = 1/2; // multiplies the wobble. higher numbers lead to weirder lines
				let angle = Math.PI / intLines * i * angle_multiplier; // this angle is used to place the control points, and it rotates
				const horizontal_line_spacing = w / 10 / intLines * 2.2; //used in start and end X position
				const vertical_line_spacing = h * 1/4 / intLines; //used in midpoint

				let speed = 1 + Math.cos(offset) * 0.1;
				let time_displacement = t * speed + offset;
				let radius_ratio = 1/100;
				let X_start = 0; //w * 1/10; //base
				X_start += horizontal_line_spacing * i; //line spacing
				X_start += Math.cos(angle + time_displacement) * w * radius_ratio; //wobble
				let Y_start = 0; //top of screen

				//Control point 1: point on a circle
				speed = 0.8 + Math.cos(offset) * 0.1;
				time_displacement = t * speed + offset;
				radius_ratio = 1/10; //determines the radius of the wobble circle
				let X_cpoint1 = w * 1/4 ; //center of the circle
				X_cpoint1 += Math.cos(angle + time_displacement) * w * radius_ratio ; //wobble
				let Y_cpoint1 = h * 1/3; //center of the circle
				Y_cpoint1 += Math.sin(angle + time_displacement) * h*radius_ratio; //wobble


				speed = 0.9 + Math.cos(offset) * 0.1;
				time_displacement = t * speed + offset;
				radius_ratio = 1/10;
				let X_cpoint2 = w*1/4 ;
				X_cpoint2 -= Math.cos(angle + time_displacement) * w*radius_ratio ; //wobble
				let Y_cpoint2 = h*2/3;
				Y_cpoint2 += Math.sin(angle + time_displacement) * h*radius_ratio; //wobble
				Y_cpoint2 -= Math.sin(angle + time_displacement) * h*radius_ratio/4; //point on a circle with center y: 1/3h, radius 1/6h, angle dependent on the current line and the time elapsed


				speed = 1.3 + Math.cos(offset) * 0.1;
				time_displacement = t * speed + offset;
				radius_ratio = 1/20;
				let X_middle = w*1/2;//base
				X_middle += Math.cos(angle + time_displacement) * w*radius_ratio; //wobble
				let Y_middle = h*1/2;//base
				if (invert_midpoints) {
					Y_middle += vertical_line_spacing * (intLines - i);//adds line spacing, bottom to top
				} else {
					Y_middle += vertical_line_spacing * i;//adds line spacing, top to bottom
				}
				Y_middle += Math.sin(angle + time_displacement) * h*radius_ratio; //wobble


				let X_cpoint3 = X_cpoint2 + (X_middle - X_cpoint2) * 2; //mirror position of cpoint2 based on middle
				let Y_cpoint3 = Y_cpoint2 + (Y_middle - Y_cpoint2) * 2; //mirror position of cpoint2 based on middle

				speed = 1.2 + Math.cos(offset) * 0.1;
				time_displacement = t * speed + offset;
				radius_ratio = 1/10;
				angle = Math.PI / intLines/2 * (i * angle_multiplier + 5); //different angle
				let X_cpoint4 = w - w*1/4;//base
				X_cpoint4 -= Math.cos(angle + time_displacement) * w*radius_ratio ; //wobble
				let Y_cpoint4 = h*2/3;//base
				Y_cpoint4 += Math.sin(angle + time_displacement) * h*radius_ratio; //wobble



				radius_ratio = 1/100;
				speed = 1 + Math.cos(offset) * 0.1;
				time_displacement = t * speed + offset;
				let X_end = w; //base
				if (invert_endpoints) { //sometimes invert the order of the arriving lines
					X_end -= horizontal_line_spacing * (intLines - i);//adds line spacing, left to right
				} else {
					X_end -= horizontal_line_spacing * i;//adds line spacing, right to left
				}
				X_end += Math.cos(angle + time_displacement) * w*radius_ratio;//wobble
				let Y_end = 0; //top of screen


				//constrain the points to be in a specific portion of the screen:
				let horizontal_ratio = 8/10;
				let horizontal_offset = 1/10;

				//if half screen is neither 'left' nor 'right' the screen ratio will not change.
				if (screen === 'left' ) {
					horizontal_ratio = 12/20;
					horizontal_offset = 0/20;
				} else if (screen === 'right') {
					horizontal_ratio = 12/20;
					horizontal_offset = 8/20;
				}
				if (screen === 'zoomed') {
					//mobile view has the animation zoomed
					horizontal_ratio = 40/20;
					horizontal_offset = -10/20;
				}

				X_start =   w * horizontal_offset + X_start * horizontal_ratio;
				X_cpoint1 = w * horizontal_offset + X_cpoint1 * horizontal_ratio;
				X_cpoint2 = w * horizontal_offset + X_cpoint2 * horizontal_ratio;
				X_middle =  w * horizontal_offset + X_middle * horizontal_ratio;
				X_cpoint3 = w * horizontal_offset + X_cpoint3 * horizontal_ratio;
				X_cpoint4 = w * horizontal_offset + X_cpoint4 * horizontal_ratio;
				X_end =     w * horizontal_offset + X_end * horizontal_ratio;

				//flip upsidedown
				if (flip) {
					Y_start = h - Y_start;
					Y_cpoint1 = h - Y_cpoint1;
					Y_cpoint2 = h - Y_cpoint2;
					Y_middle = h - Y_middle;
					Y_cpoint3 = h - Y_cpoint3;
					Y_cpoint4 = h - Y_cpoint4;
					Y_end = h - Y_end;
				}

				$.moveTo(X_start , Y_start );

				$.bezierCurveTo(X_cpoint1, Y_cpoint1, X_cpoint2, Y_cpoint2, X_middle, Y_middle);
				$.stroke();

				$.bezierCurveTo(X_cpoint3, Y_cpoint3, X_cpoint4, Y_cpoint4, X_end, Y_end);
				$.stroke();
			}
		}

		var t =  Math.random() * 100;
		var offset = Math.random() * 100;

		const invert_midpoints = Math.random() > 0.5 ;
		const invert_endpoints = Math.random() > 0.5 ;

		//is animation only half screen?
		let screen = 'full';

		if (jQuery(this).hasClass('js-animation-left')) {
			screen = 'left';
		}
		if (jQuery(this).hasClass('js-animation-right')) {
			screen = 'right';
		}
		if (window.innerWidth <= 750) {
			screen = 'zoomed';
		}

		//is animation upside-down?
		const flip = jQuery(this).hasClass('js-animation-flip');

		var run = function() {
			if (c.classList.contains("js-in-view")) {
				if (w !== window.innerWidth) {
					w = c.width = window.innerWidth;
					h = c.height = window.innerHeight;
					screen = 'full';
					if (jQuery(this).hasClass('js-animation-left')) screen = 'left';
					if (jQuery(this).hasClass('js-animation-right')) screen = 'right';
					if (window.innerWidth <= 750) screen = 'zoomed';
				}
				window.requestAnimationFrame(run);
			} else {
				//console.log('animation stop');
			}
			t += 0.003;
			draw(t, offset, invert_midpoints, invert_endpoints, screen, flip);
		};

		run()

		c.addEventListener('run', function() {
			//console.log('animation start');
			run();
		});

		// window.setInterval(run, 50);
		
	});



	const soundwave_observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {

			//console.log('Look ma! A sound wave parent element!', entry);

			const soundwaves = entry.target.querySelector('.sound-waves');
			soundwaves.classList.toggle('js-in-view', entry.isIntersecting)
			soundwaves.dispatchEvent(new CustomEvent("run"));

		});
	},
		{threshold: 0.5}
	);

	// Track .sound-waves PARENTS
	document.querySelectorAll('.sound-waves').forEach((element) => {
		soundwave_observer.observe(element.parentNode);
	});

})(jQuery);






